import { RouteConfig } from 'vue-router'
import { ERRORS_ROUTES } from './utils'


type PromiseVue = Promise<typeof import('*.vue')>

const createRoutes = (): RouteConfig[] => [
  {
    path: '/error/:code',
    name: ERRORS_ROUTES.ERRORS,
    props: ({ params: p }) => ({ ...p }),
    component: (): PromiseVue => import(
      /* webpackChunkName: "errors.error" */
      './Error.ts.vue'
    ),
  },
  {
    path: '*',
    name: ERRORS_ROUTES.ERROR_404,
    props: { code: 404 },
    component: (): PromiseVue => import(
      /* webpackChunkName: "errors.error" */
      './Error.ts.vue'
    ),
  },
]

const createModule = (): RouteConfig[] => {
  const routes = createRoutes()
  return routes
}

export default createModule
